import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker-install.component.html',
  styleUrls: ['./color-picker-install.component.css']
})
export class ColorPickerInstallComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
